import { TemplateType } from '@/api/tax-guide';
import { DirectLoginFonts } from '@/commonUtilities/fontUtils';
import { useEffect } from 'react';

type UseDynamicFontProps = {
  folderName?: string;
  template: TemplateType;
};

function useDynamicFont(props: UseDynamicFontProps): void {
  const { folderName, template } = props;

  useEffect(() => {
    if (!folderName || template !== 'custom') {
      // document.body.style.fontFamily = 'Arial Helvetica Sans';
      return;
    } else {
      const font = DirectLoginFonts.filter(font => font.name === folderName);
      if (font[0]) {
        const fontFamily =
          font[0] && font[0].font.toLowerCase().replace(/\s/g, '');
        const fontPath = `direct_logins/${folderName}/fonts/${fontFamily}.ttf`;
        loadDynamicCSS(fontFamily, fontPath);
      }
    }
  }, []);

  function loadDynamicCSS(fontFamily: string, fontPath: string) {
    const newFontFace = new FontFace(fontFamily, `url(${fontPath})`);
    newFontFace
      .load()
      .then(loadedFace => {
        document.fonts.add(loadedFace);
        const taxGuideContent = document.getElementById('taxGuideContent');
        if (taxGuideContent) {
          taxGuideContent.style.fontFamily = fontFamily;
        }
      })
      .catch(error => {
        console.error('Error loading font from the path', error);
      });
  }
}

export default useDynamicFont;
